module.exports = __webpack_public_path__ + "img/coupon_empty.6e4aa8cb.png";